<nz-sider
  class="side_navbar_v3"
  nzTheme="dark"
  [nzWidth]="isExpanded ? expandedWidth : collapsedWidth"
  [nzTrigger]="null"
  [ngClass]="{ 'expanded_state': isExpanded }"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="onSidebarMouseLeave()"
>
  <div class="sider_header">
    <div class="brand">
      <img class="brand_logo" src="assets/images/smarttos-logo-small.svg" alt="Smart TOS" />
      @if (isExpanded) {
        <div class="brand_text">
          <span class="smart">Smart</span>
          <span class="tos">TOS</span>
        </div>
      }
    </div>

    @if (isExpanded) {
      <button
        type="button"
        class="pin_btn"
        [ngClass]="{ pin_active: isPinned }"
        [attr.aria-label]="isPinned ? 'Unpin sidebar' : 'Pin sidebar'"
        (click)="togglePin($event)"
      >
        <app-svg-icon class="pin_icon" [path]="'assets/icons/sb-pin.svg'"></app-svg-icon>
      </button>
    }
  </div>

  @if (isExpanded) {
    <div class="search_wrapper">
      <div class="search_bar">
        <app-svg-icon class="search_icon" [path]="'assets/icons/search_icon.svg'"></app-svg-icon>
        <input
          #searchInput
          type="text"
          class="search_input"
          [placeholder]="'Search menu (' + searchShortcutLabel + ')'"
          [value]="searchQuery"
          (input)="onSearchChange(searchInput.value)"
        />
        @if (searchQuery) {
          <button type="button" class="search_clear" (click)="clearSearch()">
            <app-svg-icon [path]="'assets/icons/close_icon.svg'"></app-svg-icon>
          </button>
        }
      </div>
    </div>
  }

  <div class="menu_scroll">
    <ul nz-menu nzMode="inline" class="nav_menu">
      @for (parent of filteredNavigationItems; track parent.id) {
        @if (parent.children.length > 0) {
          <li
            nz-submenu
            [nzOpen]="isNodeOpen(parent.id)"
            (nzOpenChange)="onSubmenuOpenChange(parent.id, $event)"
            [nzTitle]="parentMenuTitle"
            [class.keyboard_focused]="focusedNodeId === parent.id"
            [attr.data-node-id]="parent.id"
          >
            <ng-template #parentMenuTitle>
              <span class="menu_title_row">
                @if (parent.icon) {
                  <app-svg-icon class="menu_icon" [path]="parent.icon"></app-svg-icon>
                } @else {
                  <span class="menu_icon_placeholder"></span>
                }
                <span class="menu_label">{{ parent.label }}</span>
              </span>
            </ng-template>

            <ul>
              @for (child of parent.children; track child.id) {
                @if (child.children.length > 0) {
                  <li
                    nz-submenu
                    [nzTitle]="child.label"
                    [nzOpen]="isNodeOpen(child.id)"
                    (nzOpenChange)="onSubmenuOpenChange(child.id, $event)"
                    [class.keyboard_focused]="focusedNodeId === child.id"
                    [attr.data-node-id]="child.id"
                  >
                    <ul>
                      @for (grandChild of child.children; track grandChild.id) {
                        <li
                          nz-menu-item
                          [nzSelected]="isRouteSelected(grandChild.route)"
                          [class.keyboard_focused]="focusedNodeId === grandChild.id"
                          [attr.data-node-id]="grandChild.id"
                          (click)="navigateTo(grandChild.route)"
                        >
                          {{ grandChild.label }}
                        </li>
                      }
                    </ul>
                  </li>
                } @else {
                  <li
                    nz-menu-item
                    [nzSelected]="isRouteSelected(child.route)"
                    [class.keyboard_focused]="focusedNodeId === child.id"
                    [attr.data-node-id]="child.id"
                    (click)="navigateTo(child.route)"
                  >
                    {{ child.label }}
                  </li>
                }
              }
            </ul>
          </li>
        } @else {
          <li
            nz-menu-item
            [nzSelected]="isRouteSelected(parent.route)"
            [class.keyboard_focused]="focusedNodeId === parent.id"
            [attr.data-node-id]="parent.id"
            (click)="navigateTo(parent.route)"
          >
            <span class="menu_title_row">
              @if (parent.icon) {
                <app-svg-icon class="menu_icon" [path]="parent.icon"></app-svg-icon>
              } @else {
                <span class="menu_icon_placeholder"></span>
              }
              <span class="menu_label">{{ parent.label }}</span>
            </span>
          </li>
        }
      }

      @if (isExpanded && searchQuery && filteredNavigationItems.length === 0) {
        <li class="no_results">No results for "{{ searchQuery }}"</li>
      }
    </ul>
  </div>
</nz-sider>
